import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { GetUser } from "@redotech/redo-model/user";
import { AssignState } from "@redotech/redo-return-ui/flows/rules/assign";
import { RuleTypeDetailsProps } from "@redotech/redo-return-ui/flows/rules/multiple-actions";
import { LabeledInput } from "@redotech/redo-web/labeled-input";
import { SelectDropdown } from "@redotech/redo-web/select-dropdown";
import { memo, useContext } from "react";
import * as selectCss from "../return-flow/select.module.css";

export const AssignDetails = memo(function AssignDetails({
  state,
  setState,
  disabled,
}: RuleTypeDetailsProps<AssignState>) {
  const team = useContext(TeamContext);
  const users = (team?.users || []).map((teamUser) => {
    return {
      id: (teamUser.user as GetUser)._id,
      name: (teamUser.user as GetUser).name,
    };
  });
  return (
    <LabeledInput label="User">
      <SelectDropdown
        disabled={disabled}
        options={users}
        value={state.user}
        valueChange={(e) => {
          if (e) {
            setState({ user: e });
          }
        }}
      >
        {(user: { id: string; name: string }) => {
          return (
            <div className={selectCss.value}>
              <div className={selectCss.title}>{user.name}</div>
            </div>
          );
        }}
      </SelectDropdown>
    </LabeledInput>
  );
});
